var exports = {
  "kL": "x1cb7f6e3--201470--container",
  "iE": "x1cb7f6e3--201470--wrapper",
  "fA": "x1cb7f6e3--201470--bank-block",
  "lv": "x1cb7f6e3--201470--bank-block__bank",
  "mq": "x1cb7f6e3--201470--bank-block__icon",
  "q1": "x1cb7f6e3--201470--bank-block__text",
  "VY": "x1cb7f6e3--201470--info-block",
  "l5": "x1cb7f6e3--201470--rate-block",
  "DV": "x1cb7f6e3--201470--payment-block",
  "N6": "x1cb7f6e3--201470--label-block",
};

module.exports = exports;
